export default __webpack_public_path__ + "static/media/gallery2.96989a06.png";